import { render } from "./dashboard-header.vue?vue&type=template&id=dd8187d6&ts=true"
import script from "./dashboard-header.ts?vue&type=script&lang=ts"
export * from "./dashboard-header.ts?vue&type=script&lang=ts"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__